import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { IBeverageVM } from 'app/models/beverage';
import * as fromActions from './actions';
import { ISearchFilterBeverages } from 'app/models/search-filter';


// export interface BeverageState {
//   beverages: IBeverage[];
//   error: string;
// }

export interface State extends EntityState<IBeverageVM> {
  // additional entity state properties
  selectedId: string | null;

  displayConfetti: boolean;
  topMenuTabSelected: string | null;
  filter: ISearchFilterBeverages;
  error: string;
}

export function sortByName(a: IBeverageVM, b: IBeverageVM): number {
  return a.name.localeCompare(b.name);
}
export function selectId(a: IBeverageVM): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IBeverageVM> = createEntityAdapter<IBeverageVM>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  displayConfetti: false,
  topMenuTabSelected: null,
  filter: {
    searchString: ''
  },
  error: ''
});

// const initialBeverageState: BeverageState = {
//   beverages: [],
//   error: ''
// };

export const stateName = 'beverages';

// Reducers
export const reducer = createReducer<State>(
  initialState,
  on(fromActions.setTopMenuTabSelected, (state, action) => {
    return {
      ...state,
      topMenuTabSelected: action.tab
    };
  }),
  on(fromActions.setSearch, (state, action) => {
    return {
      ...state,
      filter: {
        searchString: action.searchString
      }
    };
  }),
  on(fromActions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),
  on(fromActions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),
  on(fromActions.displayConfetti, (state, action) => {
    return {
      ...state,
      displayConfetti: action.display
    };
  }),
  on(fromActions.loadItemsFailure, (state, action) => {
    return {
      ...state,
      entities: {},
      error: action.error
    };
  }),
  on(
    fromActions.setItem,
    fromActions.setItemAndNavigate,
    (state, action) => Object.assign({ ...state, selectedId: action.id })),
  on(fromActions.addItemSuccess, (state, action) => Object.assign({ ...state, selectedId: action.id })),
  on(
    fromActions.softUpdateFailure,
    fromActions.deleteItemFailure,
    (state, action): State => { return { ...state, error: action.error }; }),

);


// get the selectors
const {
  selectAll,
  selectEntities: selectItemEntities,
  selectIds: selectItemIds,
  selectTotal
} = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

// ***** SELECTORS *******
export const getSelectedId = (state: State) => state.selectedId;
export const getDisplayConfetti = (state: State) => state.displayConfetti;
export const getState = createFeatureSelector<State>(stateName);
export const selectIds = createSelector(getState, selectItemIds);
export const selectAllEntities = createSelector(getState, selectItemEntities);
export const selectAllItems = createSelector(getState, selectAll);
//export const getAllEntities = createSelector(getState, selectEntities);

export const getCount = createSelector(getState, selectTotal);
export const selectCurrentId = createSelector(getState, getSelectedId);
export const selectDisplayConfetti = createSelector(getState, getDisplayConfetti);
export const selectCurrentItem = createSelector(selectAllEntities, selectCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);

export const selectTopMenuTabSelected = createSelector(getState, (state: State) => state.topMenuTabSelected);

export const selectBeveragesSortedByDate = createSelector(
  selectAllItems,
  (items: IBeverageVM[]) => {
    return items.sort((a, b) => {
      const aDate = a.uDate instanceof Date && !isNaN(a.uDate.getTime()) ? a.uDate : null;
      const bDate = b.uDate instanceof Date && !isNaN(b.uDate.getTime()) ? b.uDate : null;
      if (aDate && bDate) {
        return bDate.getTime() - aDate.getTime();
      } else {
        return 0;
      }
    });
  });


export const selectBeveragesWithFilter = createSelector(
  selectAllItems,
  getState,
  (items: IBeverageVM[], state: State) => {
    const searchString = state.filter.searchString.toLowerCase();
    if (!searchString) {
      return items;
    }

    return items.filter(x =>
      x.name.toLowerCase().includes(searchString) ||
      x.description?.toLowerCase().includes(searchString) ||
      (x.beerStyle && x.beerStyle.name.toLowerCase().includes(searchString))
    );

  });



// export const getBeverageWithKegs = (id: string) => createSelector(
//   selectEntity(id),
//   fromKegs.getKegsWithUnit,
//   (item: IBeverageVM, kegs: IKeg[]) => {
//     if (item && kegs) {
//       const retItem = { ...item };
//       retItem.kegs = [];

//       kegs.forEach(keg => {
//         if (keg.beverageId === id) {
//           retItem.kegs.push(keg);
//         }
//       });
//       return retItem;
//     }


//     return item;

//   }
// );

// export const getBeveragesWithKegs = createSelector(
//   getAllItems,
//   fromKegs.getKegsWithUnit,
//   (items: IBeverageVM[], kegs: IKeg[]) => {
//     return items.map((item) => {
//       return {
//         ...item,
//         kegs: kegs.filter(x => x.beverageId === item.id)
//       }
//     })
//   }
// );
